export const JUMB_TAB_ANCHOR_PREFIX = 'jt-';
